<div mat-dialog-container>
  <div class="deploy-dialog-container">


    <div class="new-upload-header"
         translate="MODAL.DEPLOY"></div>
    <div class="new-upload-subheader"
         translate="MODAL.DEPLOY_MSG"></div>
    <form [formGroup]="form">
      <div class="form-group">
        <label class="deploy-info-name"
               for="projectClient"
               translate="HEADER.CLIENT">
        </label>
        <select formControlName="projectClientCode"
                (change)="onSelectProjectClientCode()"
                class="deploy-dropdown"
                id="projectClient"
                name="projectClient">
          <option value=""></option>
          <option *ngFor="let customer of customers"
                  [ngValue]="customer.customerId"
                  [label]="customer.customerName"></option>
        </select>
      </div>

      <div class="form-group">
        <label class="deploy-info-name"
               translate="MODAL.DEPLOY_CHECKBOX"></label>
        <input type="checkbox"
               id="isUsingPC"
               name="isUsingPC"
               formControlName="isUsingPC" />
      </div>

      <div class="deploy-btn-container">
        <button class="save-btn"
                style="margin-right: 1em"
                [class.inactive]="form.invalid"
                (click)="deployEstimate()"
                translate="BUTTON.CONFIRM"></button>
        <button class="cancel-btn"
                (click)="onNoClick()"
                translate="BUTTON.CANCEL"></button>
      </div>
    </form>
  </div>
</div>
